// import React, { useState } from "react";
// // import Image from "next/image";
// // import Link from "next/link";
// import CountUp from "react-countup";

// const Redevelopment = () => {
//     return (
//         <section className="lyt-section typ-lgt-bg">
//             <div className="container">
//                 <div className="bs-counter">
//                     <div className="row">
//                         <div className="col-lg-4 col-md-4">
//                             <div className="typ-box">
//                                 <span className="icon icon-ticks"></span>
//                                 <CountUp end={500} suffix="+" />
//                                 <p className="counter-txt">Redevelopment projects completed</p>
//                             </div>
//                         </div>
//                         <div className="col-lg-4 col-md-4">
//                             <div className="typ-box">
//                                 <span className="icon icon-clock"></span>
//                                 <CountUp end={80} suffix="%" />
//                                 <p className="counter-txt">Reduction in project compliance time</p>
//                             </div>
//                         </div>
//                         <div className="col-lg-4 col-md-4">
//                             <div className="typ-box">
//                                 <span className="icon icon-buildings"></span>
//                                 <CountUp end={15000} />
//                                 <p className="counter-txt">Housing societies engaged
//                                     with GRSF</p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default Redevelopment;

import React, { useState, useEffect, useRef } from "react";
import CountUp from "react-countup";

const Redevelopment = () => {
    const [startCount, setStartCount] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setStartCount(true);
                    observer.disconnect(); // Stop observing after triggering
                }
            },
            { threshold: 0.2 } // Trigger when 20% of the section is visible
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.disconnect();
            }
        };
    }, []);

    return (
        <section className="lyt-section typ-lgt-bg" ref={sectionRef}>
            <div className="container">
                <div className="bs-counter">
                    <div className="row typ-center-row">
                        <div className="col-lg-4 col-md-4 col-6">
                            <div className="typ-box">
                                {/* <span className="icon icon-ticks"></span> */}
                                <img 
                                    src="/images/about/counter/1.svg"
                                    alt="building"
                                    className="img-fluid icon"
                                    width={50}
                                    height={50}
                                />
                                {startCount && <CountUp end={500} suffix="+" />}
                                <p className="counter-txt">
                                    Redevelopment projects completed
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-6">
                            <div className="typ-box">
                                {/* <span className="icon icon-clock"></span> */}
                                <img 
                                    src="/images/about/counter/2.svg"
                                    alt="building"
                                    className="img-fluid icon"
                                    width={50}
                                    height={50}
                                />
                                {startCount && <CountUp end={80} suffix="%" />}
                                <p className="counter-txt">
                                    Reduction in project compliance time
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-6">
                            <div className="typ-box">
                                {/* <span className="icon icon-buildings"></span> */}
                                <img 
                                    src="/images/about/counter/3.svg"
                                    alt="building"
                                    className="img-fluid icon"
                                    width={50}
                                    height={50}
                                />
                                {startCount && <CountUp end={15000} />}
                                <p className="counter-txt">
                                    Housing societies engaged with GRSF
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Redevelopment;
